import { Grid } from '@mui/material'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import MDBox from 'components/MDBox'
import { useEffect, useState } from 'react'
import ComplexStatisticsCard from 'examples/Cards/StatisticsCards/ComplexStatisticsCard'
import DefaultProjectCard from 'examples/Cards/ProjectCards/DefaultProjectCard'
import SettlementLogs from "layouts/merchantSettlements/settlementLogs"
import MDTypography from 'components/MDTypography'
import { useMaterialUIController } from 'context'
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import MDInput from 'components/MDInput'
import MDButton from 'components/MDButton'
import formatDateAndTime from "util/formatDateAndTime";
import * as Yup from 'yup';
import { useLocation } from 'react-router-dom'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import BeatLoader from "react-spinners/BeatLoader";
import { PDFDocument, rgb } from 'pdf-lib';
import logo from "assets/images/gpayb-removebg-preview.png"
import { capitalizeFirstLetter } from 'util/formatDateAndTime'
import { useNavigate } from 'react-router-dom'
import Loader from 'util/Loader'
import { useSandbox } from 'ZustandState/useSanbox'
import useAuthFetch from 'util/apiFetcher'
import { toast } from 'react-toastify';
function settleMerchant() {
    const navigate = useNavigate()
    const authFetch = useAuthFetch()
    const { state } = useLocation()
    const sandbox = useSandbox((state) => state.sandbox)
    const limit = 10
    const [page, setPage] = useState(0)
    const [csvCompleteData, setCsvCompleteData] = useState([])
    const [loading, setLoading] = useState(false)
    const [allDataLoading, setAllDataLoading] = useState(true)
    const validationSchema = Yup.object({
        // grossVolume: Yup.number().required('Gross Volume is required'),
        feesPercentage: Yup.number().min(0).max(100).required('Fees Percentage is required'),
        usdtRate: Yup.number(),
        ref: Yup.string(),
    });
    const [settlementLogs, setSettlementLogs] = useState([])
    const [controller] = useMaterialUIController()
    const {
        darkMode
    } = controller
    const [data, setData] = useState()
    const [dateRange, setDateRange] = useState({
        startDate: '',
        endDate: '',
    });
    const [grossVolume, setGrossVolume] = useState(0); // State for grossVolume
    const initialValues = {
        merchantId: state,
        // grossVolume: '',
        feesPercentage: '',
        usdtRate: '',
        ref: '',
        // notes: ''
    }
    const [netVolume, setNetVolume] = useState(0)
    const [netFees, setNetFees] = useState(0)
    const [usdtNet, setUsdtNet] = useState(0)
    const [feesPercentage, setFeesPercentage] = useState(0)
    const [usdtRate, setUsdtRate] = useState(0)
    const [openDialog, setOpenDialog] = useState(false);
    const handleCloseDialog = () => {
        setNetFees(0)
        setNetVolume(0)
        setUsdtNet(0)
        setGrossVolume('')
        setDateRange({
            startDate: '',
            endDate: ''
        });
        setOpenDialog(false);

    };


    const downloadPdfInvoice = async (log) => {
        const pdfDoc = await PDFDocument.create();
        // Set page size to A4
        const page = pdfDoc.addPage([595, 842]); // 595 x 842 are the dimensions for A4 in points
        // Add left border Line
        page.drawLine({ start: { x: 8, y: 830 }, end: { x: 8, y: 12 }, thickness: 1, color: rgb(0, 0, 0) });
        // Add right border Line
        page.drawLine({ start: { x: 587, y: 830 }, end: { x: 587, y: 12 }, thickness: 1, color: rgb(0, 0, 0) });
        // Add upper border Line
        page.drawLine({ start: { x: 8, y: 830 }, end: { x: 587, y: 830 }, thickness: 1, color: rgb(0, 0, 0) });
        // Add bottom border Line
        page.drawLine({ start: { x: 8, y: 12 }, end: { x: 587, y: 12 }, thickness: 1, color: rgb(0, 0, 0) });

        // Add Company Logo
        const logoUrl = logo; // Replace with the actual path or URL to your logo
        const logoImageBytes = await fetch(logoUrl).then(res => res.arrayBuffer());
        const logoImage = await pdfDoc.embedPng(logoImageBytes);
        page.drawImage(logoImage, { x: 380, y: 770, width: 200, height: 65 });

        // Add Merchant Information
        const merchantInfo = [
            { title: 'Merchant Name', value: capitalizeFirstLetter(data?.business_name) },
            { title: 'Settlement Date', value: formatDateAndTime(log.createdAt).formattedDate || '' },
            { title: 'Settlement No.', value: (log.txIndex).toString() },
        ];

        merchantInfo.forEach(({ title, value }, index) => {
            page.drawText(`${title}:`, { x: 50, y: 700 - index * 30, size: 18, color: rgb(0, 0, 0) });
            page.drawText(value, { x: 350, y: 700 - index * 30, size: 18, color: rgb(0, 0, 0) });
        });

        // Add Settlement Report
        page.drawRectangle({ x: 50, y: 580, width: 500, height: 30, color: rgb(0, 0, 0) });
        page.drawText('Settlement Report', { x: 200, y: 587, fontSize: 11, color: rgb(1, 1, 1) });

        const feeCharged = log?.netFees;
        const feeChargedValue = feeCharged !== undefined ? feeCharged.toFixed(0).toString() : '';

        // Add Data Section
        const dataSection = [
            { title: 'Merchant Volume', value: (log?.grossVolume && log.grossVolume.toFixed(0) || '').toString() },
            { title: 'Gateway Fees', value: (log?.feesPercentage && log?.feesPercentage + '%' || '').toString() },
            { title: 'Net Gateway Fees', value: feeChargedValue },
        ];

        dataSection.forEach(({ title, value }, index) => {
            page.drawText(title, { x: 50, y: 530 - index * 35, size: 15, color: rgb(0, 0, 0) });
            page.drawText(value, { x: 400, y: 530 - index * 35, size: 15, color: rgb(0, 0, 0) });
        });

        // Add Footer Line
        page.drawLine({ start: { x: 50, y: 180 }, end: { x: 550, y: 180 }, thickness: 1, color: rgb(0, 0, 0) });

        // Add Footer Data
        const footerData = [
            { title: 'Merchant Net', value: (log?.netVolume && log?.netVolume.toFixed(0) || '').toString() },
            { title: 'USDT Rate', value: (log?.usdtRate).toString() || '' },
            { title: 'USDT Net Settlement', value: (log?.usdtNet?.toFixed(0)).toString() },
        ];

        footerData.forEach(({ title, value }, index) => {
            page.drawText(title, { x: 50, y: 150 - index * 30, size: 15, color: rgb(0, 0, 0) });
            page.drawText(value, { x: 400, y: 150 - index * 30, size: 15, color: rgb(0, 0, 0) });
        });

        let filename = `invoice,${capitalizeFirstLetter(data?.business_name)} ${formatDateAndTime(log.createdAt).formattedDate}.pdf`

        // Save the PDF
        const pdfBytes = await pdfDoc.save();

        // Trigger download
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
    }
    const getPayinVolume = async () => {
        try {
            const res = await authFetch(`/merchantSettlementData/${state}`, {
                method: 'GET',
            }, false)
            if (!res) return;
            setData(res?.responseData)
        } catch (err) {
            console.log("Error Fetching getPayinVolume: ", err)
        }
    }
    const getSettlementLogs = async () => {
        try {
            const res = await authFetch(`/getPayinSettlementLog/${state}?limit=${limit}&skip=${limit * page}`, {
                method: 'GET',
            }, false)
            if (!res) return;
            setSettlementLogs(res?.responseData)
        } catch (err) {
            console.log("Error Fetching getPayinSettlementLog: ", err)
        }
    }
    const getSettlementLogsForCsv = async (values) => {
        try {
            const res = await authFetch(`/getPayinSettlementLog/${values.id}?limit=${values.limit}&skip=${values.limit * values.csvPage}`, {
                method: 'GET',
            }, false)
            if (!res) return;
            return res?.responseData
        } catch (err) {
            console.log("Error Fetching getSettlementLogsForCsv: ", err)
        }
    }

    const handleSettle = async (values, { setSubmitting }) => {
        try {
            const { startDate, endDate } = dateRange
            if (!startDate || !endDate) {
                toast.error("Both start date and end date must be selected", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                });
                return;
            }
            values.netFees = netFees
            values.netVolume = netVolume
            values.netUSDT = usdtNet
            values.grossVolume = grossVolume
            values.start_date = dateRange.startDate
            values.end_date = dateRange.endDate
            if (grossVolume === 0) {
                toast.warning("Gross Volume received is 0. Cannot settle.", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                });
                return;
            }
            const res = await authFetch(`/settleMerchantPayin`, {
                method: 'POST',
                body: JSON.stringify(values)
            }, true)
            if (!res) return;
            setSubmitting(false);
            page > 0 ? (setPage(0), getPayinVolume()) : (getSettlementLogs(), getPayinVolume())
            handleCloseDialog()
        } catch (error) {
            console.log("Error Fetching handleSettle: ", error)
            // Reset submitting state
            setSubmitting(false);
        }
    };

    const handleDateChange = async () => {
        try {
            const { startDate, endDate } = dateRange;
            // Ensure both dates are selected before making the API call
            if (!startDate || !endDate) {
                toast.error("Both start date and end date must be selected", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                });
                return;
            }

            // Prepare the request body with the selected dates and emailId
            let body = {
                start_date: startDate,
                end_date: endDate,
                emailId: data?.emailId // Assuming data is defined and contains emailId
            };

            // Make the API request
            const res = await authFetch(`/payinGrossVolume`, {
                method: 'POST',
                body: JSON.stringify(body),
            }, false);
            if (!res) return;

            const totalAmount = res?.responseData?.totalAmount;
            if (totalAmount !== undefined && totalAmount !== null) {
                // Set the grossVolume state to the totalAmount if it is not undefined or null
                setGrossVolume(totalAmount);
                handleCalculateAgainOnDateChange(totalAmount, feesPercentage, usdtRate)
            } else {
                // Optionally, you can set grossVolume to an empty string or a default value if totalAmount is null or undefined
                setGrossVolume(0); // or any other default value
            }
        } catch (error) {
            console.log("Error Fetching handleDateChange: ", error)
            // Reset submitting state
        }
    }
    const downloadSettlementLogs = async () => {
        setLoading(true)
        setCsvCompleteData([])
        let csvPage = 0
        let responseData = true
        do {
            let body = {
                id: state,
                limit: 500,
                csvPage,
            }

            await getSettlementLogsForCsv(body).then((res) => {
                if (res?.length === 0) responseData = false;
                csvCompleteData.push(...res)
            })
            csvPage++
        } while (responseData)

        // Create the CSV content
        const csvContent = [
            ["Settlement No", "Time", "Date", "Gross Volume", "Net Fees", "Net Volume", "USDT Rate", "USDT Net", "Ref",],
            ...csvCompleteData.map(({ txIndex, createdAt, grossVolume, netFees, netVolume, usdtRate, usdtNet, ref }) => [
                txIndex,
                formatDateAndTime(createdAt, true).formattedTime || '',
                formatDateAndTime(createdAt, true).formattedDate || '',
                grossVolume,
                netFees,
                netVolume,
                usdtRate,
                usdtNet.toFixed(1),
                ref || '',
            ]),
        ].map(row => row.join(',')).join('\n');

        // Create a Blob containing the CSV data
        const blob = new Blob([csvContent], { type: 'text/csv' });

        // Create a download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'settlement.csv';

        // Programmatically click the link to trigger the download
        a.click();

        // Clean up
        URL.revokeObjectURL(url);
        setLoading(false)
    }

    const calculateNetVolume = (grossVolume, fee, usdtRates) => {
        const fees = (fee / 100) * grossVolume; // Calculating fees based on percentage
        const net = grossVolume - fees; // Calculating net volume
        setNetFees(fees)
        setNetVolume(net);
        calculateNetUSDT(usdtRates, net)
    }
    const calculateNetUSDT = (rate, netVolume) => {
        const net = (netVolume !== undefined && netVolume !== '') ? parseFloat(netVolume) : 0;
        const usdtRate = (rate !== undefined && rate !== '') ? parseFloat(rate) : 0;

        if (usdtRate === 0) {
            // Handle division by zero case
            setUsdtNet(0);
        } else {
            const netUSDT = net / usdtRate; // Calculating net USDT based on rate
            setUsdtNet(netUSDT);
        }
    }
    const handleCalculateAgainOnDateChange = (grossVolume, feesPercentage, usdtRate) => {
        calculateNetVolume(grossVolume, feesPercentage, usdtRate)
    }

    useEffect(() => {
        setAllDataLoading(true)
        getPayinVolume().then(() => {
            setAllDataLoading(false)
        })
    }, [state, sandbox])
    useEffect(() => {
        getSettlementLogs()
    }, [state, page, sandbox])

    useEffect(() => {
        // Trigger handleDateChange only when both dates are selected
        if (dateRange.startDate && dateRange.endDate) {
            handleDateChange();

        }
    }, [dateRange.startDate, dateRange.endDate]);
    return (
        <DashboardLayout>
            <DashboardNavbar />
            {
                allDataLoading && data ? (<Loader />) : (
                    <MDBox py={3}>
                        <MDBox mt={1}>
                            {data && <Grid display={'flex'} flexDirection={'row'} container spacing={3}>
                                <Grid xl={3}>
                                    <DefaultProjectCard
                                        business={data?.business_name}
                                        email={data?.emailId}
                                        name={`${data?.first_name} ${data?.last_name}`}
                                        btn={setOpenDialog}
                                        type="settle"
                                    />
                                </Grid>
                                <Grid xl={9}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} lg={2.4} xl={2.4}>
                                            <MDBox mb={1.5}>
                                                <ComplexStatisticsCard
                                                    color="7FDF9A"
                                                    title="Today's Volume"
                                                    count={data.last24hr.toFixed(0)}
                                                />
                                            </MDBox>
                                        </Grid>

                                        <Grid item xs={12} lg={2.4} xl={2.4}>
                                            <MDBox mb={1.5}>
                                                <ComplexStatisticsCard
                                                    color="FFFED2"
                                                    title="Yesterday's Volume"
                                                    count={`${data.yesterday.toFixed(0)}`}
                                                />
                                            </MDBox>
                                        </Grid>
                                        <Grid item xs={12} lg={2.4} xl={2.4}>
                                            <MDBox mb={1.5}>
                                                <ComplexStatisticsCard
                                                    color="D4BEF0"
                                                    title="Total Volume"
                                                    count={`${data.totalVolume.toFixed(0)}`}
                                                />
                                            </MDBox>
                                        </Grid>
                                        <Grid item xs={12} lg={2.4} xl={2.4}>
                                            <MDBox mb={1.5}>
                                                <ComplexStatisticsCard
                                                    color="BBF2EA"
                                                    title="Total Settlement"
                                                    count={`${data.totalSettlements.toFixed(0)}`}
                                                />
                                            </MDBox>
                                        </Grid>
                                        <Grid item xs={12} lg={2.4} xl={2.4}>
                                            <MDBox mb={1.5}>
                                                <ComplexStatisticsCard
                                                    color="C9DEDE"
                                                    title="Wallet Balance"
                                                    count={`${data.payinBalance.toFixed(0)}`}
                                                />
                                            </MDBox>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>}
                            {/* settlementLogs */}
                            <MDBox mt={5} mx={0.5} ml={3}>
                                <Grid display={'flex'} flexDirection={'row'} container spacing={3}>
                                    <Grid xl={12}>
                                        <MDBox display={'flex'} flexDirection={'row'}>
                                            <MDTypography variant="h6" color={darkMode ? "white" : "black"}>Settlement Logs</MDTypography>
                                            <MDBox pl={3}>
                                                {
                                                    loading ? (<BeatLoader
                                                        color="#36d7b7"
                                                        cssOverride={{}}
                                                        size={10}
                                                    />) : (
                                                        <FileDownloadOutlinedIcon onClick={() => downloadSettlementLogs()} sx={{ cursor: "pointer", fontWeight: "bold" }} color={darkMode ? "white" : "black"} fontSize="medium" />
                                                    )
                                                }

                                            </MDBox>
                                        </MDBox>
                                    </Grid>

                                    <SettlementLogs pages={page} pageSetter={setPage} logs={settlementLogs} downloadInvoice={downloadPdfInvoice} />

                                </Grid>
                            </MDBox>
                        </MDBox>
                    </MDBox>
                )
            }

            <Dialog PaperProps={{
                style: {
                    minHeight: '35vh',
                    minWidth: '45vw',
                    background: darkMode ? "#344767" : "white",
                    boxShadow: '0px 10px 20px 0px rgba(0,0,0,0.2)', // Shadow effect
                    borderRadius: '10px', // Rounded corners
                    position: 'absolute',
                    left: '50%', // Adjust the left value to move the dialog to the right
                },
            }} open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle>SETTLEMENT</DialogTitle>
                <DialogContent>
                    <MDBox px={1} py={1} display={'flex'} flexDirection={'row'} justifyContent={'flex-end'}>
                        <MDTypography px={2} color="text" fontWeight="medium" fontSize="large" variant="caption" >
                            Net Volume: {netVolume?.toFixed(2)}
                        </MDTypography>
                        <MDTypography px={2} color="text" fontWeight="medium" fontSize="large" variant="caption" >
                            Net Fees: {netFees?.toFixed(2)}
                        </MDTypography>
                        <MDTypography px={2} color="text" fontSize="large" fontWeight="medium" variant="caption" >
                            Usdt Net: {usdtNet?.toFixed(2)}
                        </MDTypography>
                    </MDBox>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSettle}
                    >
                        {({ isSubmitting, values, setFieldValue }) => (
                            <Form>
                                <MDBox mb={2} display="flex" flexDirection="row" justifyContent="space-between">
                                    <MDBox width="48%">
                                        <Field type="date" label="Start Date" as={MDInput} fullWidth name="startDate" InputLabelProps={{
                                            shrink: true,
                                        }} onChange={(e) => {
                                            setDateRange(prev => ({
                                                ...prev,
                                                startDate: e.target.value,
                                            }));


                                        }} />
                                        <MDTypography color="error" variant="caption" >
                                            <ErrorMessage name="startDate" component="div" />
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox width="48%">
                                        <Field type="date" label="End Date" as={MDInput} fullWidth name="endDate" InputLabelProps={{
                                            shrink: true,
                                        }} onChange={(e) => {
                                            setDateRange(prev => ({
                                                ...prev,
                                                endDate: e.target.value,
                                            }));

                                        }} />
                                        <MDTypography color="error" variant="caption" >
                                            <ErrorMessage name="endDate" component="div" />
                                        </MDTypography>
                                    </MDBox>
                                </MDBox>
                                <MDBox mb={2}>
                                    <Field type="number" label="Gross Volume" as={MDInput} fullWidth name="grossVolume" disabled
                                        value={grossVolume}
                                    />
                                    <MDTypography color="error" variant="caption" >
                                        <ErrorMessage name="grossVolume" component="div" />
                                    </MDTypography>
                                </MDBox>
                                <MDBox mb={2}>
                                    <Field type="number" label="Fees %" as={MDInput} fullWidth name="feesPercentage"
                                        onChange={(e) => {
                                            setFieldValue('feesPercentage', e.target.value)
                                            calculateNetVolume(grossVolume, e.target.value, values.usdtRate)
                                            setFeesPercentage(e.target.value)
                                        }}
                                    />
                                    <MDTypography color="error" variant="caption" >
                                        <ErrorMessage name="feesPercentage" component="div" />
                                    </MDTypography>
                                </MDBox>
                                <MDBox mb={2}>
                                    <Field type="number" label="USDT Rate" as={MDInput} fullWidth name="usdtRate"
                                        onChange={(e) => {
                                            setFieldValue('usdtRate', e.target.value)
                                            calculateNetUSDT(e.target.value, netVolume)
                                            setUsdtRate(e.target.value)
                                        }}
                                    />
                                    <MDTypography color="error" variant="caption" >
                                        <ErrorMessage name="usdtRate" component="div" />
                                    </MDTypography>
                                </MDBox>
                                <MDBox mb={2}>
                                    <Field type="text" label="Ref" as={MDInput} fullWidth name="ref" />
                                    <MDTypography color="error" variant="caption" >
                                        <ErrorMessage name="ref" component="div" />
                                    </MDTypography>
                                </MDBox>
                                <MDBox display={'flex'} flexDirection={'row'}>
                                    <MDBox>
                                        <MDButton
                                            type="submit" color="success" disabled={isSubmitting}
                                        >
                                            {isSubmitting ? 'Settling...' : 'Settle Merchant'}
                                        </MDButton>
                                    </MDBox>
                                    <MDBox ml={3}>
                                        <MDButton
                                            onClick={handleCloseDialog} color="error"
                                        >
                                            Cancel
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </Form>
                        )}

                    </Formik>
                </DialogContent>

            </Dialog>

        </DashboardLayout>
    )
}

export default settleMerchant